import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { Alliance, AllianceWithMembers } from 'src/app/interfaces/alliance.interface';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-alliance-detail',
  templateUrl: './alliance-detail.component.html',
})
export class AllianceDetailComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private id: number;
  alliance: AllianceWithMembers | undefined;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.id = -1;
    this.subscription = this.route.paramMap.subscribe((params) => {
      this.id = Number.parseInt(params.get('id') || '-1');
      this.loadAlliance();
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async loadAlliance() {
    try {
      this.alliance = await this.apiService.fetchAlliance(this.id);
    } catch (error) {
      handleApiError(this.authService, this.router, error);
    }
  }
}
